import React from 'react';
import { Container } from 'react-bootstrap';

class Footer extends React.Component {
    render() {
        return (
        <footer className="footer">
            <Container fluid>
            <br />
            <p>This website is under construction.</p>
            </Container>
        </footer>
        );
    }
}

export default Footer;